module.exports = __webpack_public_path__ + "media/images/flags/32/Belize-f406067c86cf4e70e4d9aaea2d92d909.png";